	import { mapGetters } from 'vuex';
	import Shortcodes from '../mixins/Shortcodes';
	import fielvalue from './fieldvalue';
	let jsPDF = require('jspdf');
	require('jspdf-autotable');

    export default {
		mixins: [fielvalue],
		computed: {
			...mapGetters([
				'keyedFields'
			]),
			docwidth(){
				 return 210 - (2 * this.margin);
			},
			singlewidth(){
				return this.docwidth / 4;
			}
		},
        data() {
            return {
				margin: null,
				offset: null,
				rowspacing: null,
				pdf: null,
				rows: null,
				images: null,
				defaultBlockConfig: {
                    alignment: 'left',
                    font_size: 14,
                    image_width: null,
                    mt: 0,
                    mr: 0,
                    mb: 0,
                    ml: 0
				}
            }
        },
		methods: {
			addLineTest(fontsize, left, loops = 5, text = 'TEST'){
				let offset = 8,
					textheight = (fontsize/4),
					boxheight = (fontsize/3) + (fontsize/40) + 2;
				this.pdf.setFontSize(fontsize);
				for(let x = 1; x <= loops; x++){
					this.pdf.text(text+x, left, offset + textheight);
					offset = offset + boxheight;
				}
			},
			addCell(cellobj, left, top){
				let colspan = (cellobj.colspan ? cellobj.colspan : 1),
					rowspan = (cellobj.rowspan ? cellobj.rowspan : 1),
					cell = {
						height: 0,
						top: top,
						left: this.margin + (this.singlewidth * left),
						width: this.singlewidth * colspan,
						leftspan: left,
						colspan: colspan,
						rowspan: rowspan,
						block: null
					};

				if(cellobj.block){
					let cellclone = _.cloneDeep(cellobj);
					cellclone.block.configuration = Object.assign({}, this.defaultBlockConfig, cellobj.block.configuration);
					if(cellobj.block.type === 'text'){
						Object.assign(cell, this.addTextBlock(cellclone, cell));
					}else if(cellobj.block.type === 'image'){
						Object.assign(cell, this.addImageBlock(cellclone, cell));
					}else if(cellobj.block.type === 'table'){
						Object.assign(cell, this.addTableBlock(cellclone, cell));
					}
				}
				return cell;
			},
			addImageBlock(cellobj, cell) {
				let config = cellobj.block.configuration,
					img = this.images[cellobj.block.value],
					cellwidth = cell.width - (parseInt(config.ml) + parseInt(config.mr)),
					width = (cellobj.block.configuration.image_width & cellobj.block.configuration.image_width < cellwidth ? cellobj.block.configuration.image_width : cellwidth),
					height = (width / img.width) * img.height,
					left = cell.left + parseInt(config.ml),
					top = cell.top + parseInt(config.mt);
				this.pdf.addImage(img.data, img.type, cell.left, cell.top, width, height);
				cell.height = height + parseInt(config.mt) + parseInt(config.mb);
				return cell;
			},
			addRow(rowobj, overflows) {
				let row = {
						cells: [],
						top: this.offset,
						height: 0,
						overflows: {},
						currentleft: 0
					};

				for (let x = 0, cellObj; cellObj = rowobj.cells[x]; x++){
					row = this.checkOverflow(row, overflows);
					let cell = this.addCell(cellObj, row.currentleft, row.top);
					if(cell.height > row.height){
						if(cell.rowspan > 1){

						}else{
							row.height = cell.height;
						}
					}
					if(cell.rowspan === 1){
						if(cell.height > row.height)
							row.height = cell.height;
					}else{
						row.overflows[row.currentleft] = {
							rowspan: (cell.rowspan - 1),
							colspan: cell.colspan,
							height: cell.height
						}
					}

					row.currentleft = row.currentleft + cell.colspan;
					row.cells.push(cell);
				}

				for(let left in row.overflows){
					row.overflows[left].height = (row.overflows[left].height > row.height ? row.overflows[left].height - row.height : 0)
				}

				this.rows.push(row);
				this.offset = this.offset + row.height;
				return row;
			},
			addTableBlock(cellobj, cell) {
				let config = cellobj.block.configuration,
					fields = cellobj.block.value,
					headers = [],
					rows = [];
				for (let x = 0, field_id; field_id = fields[x]; x++){
					// let field = this.keyedFields[fields[x]],
						// value = this.keyedFieldValues[field.id];
					if(typeof field_id === 'string'){
						headers.push(field_id.split(':')[0]);
					}else{
						headers.push(this.keyedFields[field_id].name);
					}
					// rows.push(value.value);
				}
				let totals = {};
				for (let y = this.order.orderitems.length - 1; y >= 0; y--){
					let row = [];
					for (let x = 0, field_id; field_id = fields[x]; x++){
						let val = '';
						if(typeof field_id === 'string'){
							val = field_id.split(':').length > 1 ? field_id.split(':')[1] : field_id;
							val = this.replaceShortcodes({
								value: val,
								rowindex: y,
								keyedFieldValues: this.keyedFieldValues,
								assignment_type: this.type
							});
						}else{
							let field = this.keyedFields[field_id];
							val = this.keyedFieldValues[field_id];
								
							if (val && val.orderitem) val = val[y];
							val = val ? this.getValue(field, val) : '';
						}
						if(config.totals && config.totals.indexOf(field_id) > -1){
							if(!totals[field_id])
								totals[field_id] = 0;
							totals[field_id] += parseFloat(val);
						}
						row.push(val);
					}
					rows.push(row);
				}
				if(config.totals && config.totals.length){
					let totalrow = [];
					for (let x = 0, field_id; field_id = fields[x]; x++){
						let val = !isNaN(totals[field_id]) ? parseFloat(totals[field_id].toFixed(8)) : '';
						if(x === 0) 
						val = 'Totals: ' + val;
						totalrow.push(val);
					}
					rows.push(totalrow);
				}
				let theme = this.$store.state.theme && this.$store.state.theme.dark ? 'dark' : 'light',
					color = this.hexToRgb(this.$vuetify.theme.themes[theme].primary),
					textcolor = this.darks.primary ? 255 : 0;
				this.pdf.autoTable(headers, rows, {
					headerStyles: { fillColor: [color.r, color.g, color.b], textColor: textcolor },
					startY: cell.top + parseInt(config.mt),
					margin: {
						left: this.margin + parseInt(config.ml),
						right: this.margin + parseInt(config.mr)
					},
					drawCell: (cell, data) => {
						var rows = data.table.rows;
						if (config.totals && config.totals.length && data.row.index === rows.length - 1) {
							data.doc.setFillColor(color.r, color.g, color.b).setTextColor(textcolor);
						}
					},
					// columnStyles: {
					// 	0 : {
					// 		columnWidth : 60
					// 	},
					// 	1 : {
					// 		columnWidth : 'auto'
					// 	},
					// 	2 : {
					// 		columnWidth : 60
					// 	},
					// 	3 : {
					// 		columnWidth : 80
					// 	},
					// 	4 : {
					// 		columnWidth : 80
					// 	}
					// },
					// headerStyles : {
					// 	fillColor: [146,35,39]
					// }
				});
				cell.height = (8 * (1 + this.order.orderitems.length)) + parseInt(config.mt) + parseInt(config.mb);
				if(config.totals && config.totals.length)
					cell.height = cell.height + 8;
				if(cell.height > 274){
					cell.height = cell.height - 274;
				}
				return cell;
			},
			addTextBlock(cellobj, cell) {
				let config = cellobj.block.configuration,
					height = parseInt(config.mt),
					fontsize = cellobj.block.configuration.font_size,
					alignment = cellobj.block.configuration.alignment,
					textheight = (fontsize/4),
					boxheight = (fontsize/3) + (fontsize/40) + 2;
				this.pdf.setFontSize(fontsize);
				if(alignment === 'center'){
 					cell.left = cell.left + (cell.width / 2);
				}else if(alignment === 'right'){
					cell.left = cell.left + cell.width - parseInt(config.mr);
				}else{
					cell.left = cell.left + parseInt(config.ml);
				}
				for(let x = 0, val; val = cellobj.block.value[x]; x++){
					let value = this.replaceShortcodes({
							value: val,
							keyedFieldValues: this.keyedFieldValues,
							assignment_type: this.type
						});
					this.pdf.text(value, cell.left, cell.top + height + textheight, alignment);
					if(value)
						height = height + boxheight;
				}
				cell.height = height + parseInt(config.mb);
				return cell;
			},
			checkOverflow(row, overflows){
				let left = row.currentleft,
					overflow = overflows[left];

				if(overflow){
					if(overflow.rowspan > 1){
						row.overflows[left] = {
							rowspan: (overflow.rowspan - 1),
							colspan: overflow.colspan,
							height: overflow.height
						}
					}else{
						row.height = (overflow.height > row.height ? overflow.height : row.height);
					}
					row.currentleft = row.currentleft + overflow.colspan;
					row = this.checkOverflow(row, overflows);
				}
				return row;
			},
			createPdf(exportobj){
				try {
					// Default export is a4 paper, portrait, using milimeters for units
					// 1 font size = 2mm
					// portrait width = 210mm

					let overflows = {};
					this.reset();
					this.margin = parseInt(exportobj.configuration.padding);
					this.pdf = new jsPDF();
					this.offset = this.offset + this.margin;

					this.loadImages(exportobj).then(() => {
						for(let x = 0, rowObj; rowObj = exportobj.pdfrows[x]; x++){
							let row = this.addRow(rowObj, overflows);
							overflows = row.overflows;
						}
						let name = '';
						if(exportobj.configuration.filename){
							name = this.replaceShortcodes({
								value: exportobj.configuration.filename,
								keyedFieldValues: this.keyedFieldValues,
								assignment_type: this.type
							}).replace(/\./g, '').replace(/ /g, '_') + '.pdf';
						}else{
							name = exportobj.name+'.pdf';
						}
						this.pdf.save(name);
					});
				} catch (err) {
					console.error(err);
				}
			},
			loadBase64Image(url){
				return new Promise((resolve, reject) => {
					var xhr = new XMLHttpRequest(),
						result = null,
						self = this;
					xhr.onload = function() {
						var reader = new FileReader(),
							type = xhr.response.type.replace('image/', '').toUpperCase();

						reader.onloadend = function() {
							var image = new Image();
							image.src = reader.result;
							image.onload = function() {
								self.images[url] = {
									data: reader.result,
									width: this.width,
									height: this.height,
									type: type
								};
							};
							resolve();
						}
						reader.readAsDataURL(xhr.response);
					};
					xhr.open('GET', url);
					xhr.responseType = 'blob';
					xhr.send();
				});
			},
			loadImages(exportobj) {
				let images = 0,
					loaded = 0;

				return new Promise((resolve, reject) => {
					for (let x = 0, row; row = exportobj.pdfrows[x]; x++){
						for(let y = 0, cell; cell = row.cells[y]; y++){
							if(cell.block.type === 'image'){
								images++;
								this.loadBase64Image(cell.block.value).then(() => {
									loaded++;
								});
							}
						}
					}
					let interval = setInterval(() => {
						if(images === loaded){
							clearInterval(interval);
							resolve();
						}
					}, 500)
				});
			},
			reset() {
				this.margin = 15;
				this.offset = 0;
				this.rowspacing = 2;
				this.pdf = null;
				this.rows = [];
				this.images = {};
			},
			hexToRgb(hex) {
				var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
				return result ? {
				  	r: parseInt(result[1], 16),
				  	g: parseInt(result[2], 16),
				  	b: parseInt(result[3], 16)
				} : null;
			}  
		}
    }
